import Palette from './Palette';
import StructuralElement from '../../chem/StructuralElement';

const palette = new Palette('VMD', 'VM');

palette.colors = [
  /* eslint-disable no-magic-numbers */
  0x0000FF, // blue
  0xFF0000, // red
  0x606060, // gray
  0xFF8000, // orange
  0xFFFF00, // yellow
  0x808033, // tan
  0x999999, // silver
  0x00FF00, // green
  0xFFFFFF, // white
  0xFF9999, // pink
  0x40C0C0, // cyan
  0xA600A6, // purple
  0x80E666, // lime
  0xE666B3, // mauve
  0x804D00, // ochre
  0x8080C0, // ice blue
  /* eslint-enable no-magic-numbers */
];

palette.defaultElementColor = 0x804D00;

// DO NOT EDIT MANUALLY! Autogenerated from atom_types.csv by atom_types.py.
palette.elementColors = {
  /* eslint-disable no-magic-numbers */
  H: 0xFFFFFF,
  C: 0x40BFBF,
  N: 0x0000FF,
  O: 0xFF0000,
  P: 0x808033,
  S: 0xFFFF00,
  /* eslint-enable no-magic-numbers */
};

palette.defaultResidueColor = 0x40C0C0;

// DO NOT EDIT MANUALLY! Autogenerated from residue_types.csv by residue_types.py.
palette.residueColors = {
  /* eslint-disable no-magic-numbers */
  ALA: 0x0000FF,
  ARG: 0xFFFFFF,
  ASN: 0x808033,
  ASP: 0xFF0000,
  CYS: 0xFFFF00,
  GLN: 0xFF8000,
  GLU: 0xFF9999,
  GLY: 0xFFFFFF,
  HIS: 0x40C0C0,
  ILE: 0x00FF00,
  LEU: 0xFF9999,
  LYS: 0x40C0C0,
  MET: 0xFFFF00,
  PHE: 0xA600A6,
  PRO: 0x804C00,
  SER: 0xFFFF00,
  THR: 0xE666B3,
  TRP: 0x999999,
  TYR: 0x00FF00,
  VAL: 0x808033,
  A: 0x0000FF,
  C: 0xFF8000,
  G: 0xFFFF00,
  T: 0xA600A6,
  U: 0x00FF00,
  DA: 0x0000FF,
  DC: 0xFF8000,
  DG: 0xFFFF00,
  DT: 0xA600A6,
  DU: 0x00FF00,
  '+A': 0x0000FF,
  '+C': 0xFF8000,
  '+G': 0xFFFF00,
  '+T': 0xA600A6,
  '+U': 0x00FF00,
  WAT: 0x40C0C0,
  H2O: 0x40C0C0,
  HOH: 0x40C0C0,
  /* eslint-enable no-magic-numbers */
};

palette.chainColors = [0xFFFFFF].concat(palette.colors);

const StructuralElementType = StructuralElement.Type;

palette.secondaryColors = {
  [StructuralElementType.HELIX_ALPHA]: 0xA600A6,
  [StructuralElementType.HELIX_310]: 0x0000FF,
  [StructuralElementType.HELIX_PI]: 0xFF0000,
  [StructuralElementType.STRAND]: 0xFFFF00,
  [StructuralElementType.BRIDGE]: 0x808033,
  [StructuralElementType.TURN]: 0x40C0C0,
};

export default palette;
